import { Controller } from "@hotwired/stimulus"
import { average, no_Zero_Formater } from "../echart-helper";

let departmentReceiveChartByPersonSummary;
let departmentReceiveChartByPersonCategory;

export default class extends Controller {
  connect() {
    departmentReceiveChartByPersonSummary = echarts.init(document.getElementById('department-receive-chart-by-person-summary'));
    departmentReceiveChartByPersonCategory = echarts.init(document.getElementById('department-receive-chart-by-person-category'));

    const chartDataset = JSON.parse(this.data.get("chart_dataset"));
    const rowCount = chartDataset.length - 1;
    const columnCount = chartDataset[0].length - 1;
    const visiblePersonCount = Math.min(rowCount, Math.max(6, Math.floor(72 / Math.max(columnCount, 1))));
    const isDarkTheme = document.body.dataset.coreuiTheme === "dark";
    const chartTitleColor = isDarkTheme ? '#f8f9fa' : '#212529';
    const chartTextColor = isDarkTheme ? '#d7dfeb' : '#495057';
    const chartAxisColor = isDarkTheme ? '#aebccc' : '#6c757d';
    const chartSplitLineColor = isDarkTheme ? 'rgba(215, 223, 235, 0.35)' : '#d9dfe7';
    const chartDataLabelStyle = isDarkTheme ? {
      color: chartTitleColor,
      textBorderColor: '#111827',
      textBorderWidth: 2
    } : {};
    const chartTooltipStyle = {
      backgroundColor: isDarkTheme ? '#202a3a' : '#ffffff',
      borderColor: chartAxisColor,
      textStyle: { color: chartTitleColor }
    };

    const biTypes = [];
    for (let i = 1; i <= columnCount; i++) {
      biTypes.push(chartDataset[0][i]);
    }

    const personXAxis = [];
    for (let i = 1; i <= rowCount; i++) {
      personXAxis.push(chartDataset[i][0]);
    }

    const personRealAmounts = [];
    for (let i = 1; i <= rowCount; i++) {
      let person_summary = 0;
      for (let j = 1; j <= columnCount; j++) {
        person_summary += chartDataset[i][j];
      }
      personRealAmounts.push(Math.round(person_summary));
    }

    const avgPersonRealAmounts = average(personRealAmounts);

    const biTypeByName = [];
    for (let i = 1; i <= columnCount; i++) {
      let bi_types = [];
      for (let j = 1; j <= rowCount; j++) {
        bi_types.push(chartDataset[j][i]);
      }
      biTypeByName.push({
        name: chartDataset[0][i],
        type: 'bar',
        label: {
          show: true,
          position: 'insideTop',
          formatter: no_Zero_Formater,
          ...chartDataLabelStyle
        },
        data: bi_types,
        barMinWidth: 8,
        barMaxWidth: 14,
        barGap: '10%',
        barCategoryGap: '18%'
      });
    }

    const dataZoom = (visibleCount) => {
      if (rowCount <= visibleCount) { return []; }

      const end = Math.max((visibleCount / rowCount) * 100, 1);
      return [{
        type: 'inside',
        xAxisIndex: 0,
        start: 0,
        end,
        zoomOnMouseWheel: false,
        moveOnMouseWheel: true,
        moveOnMouseMove: true
      }, {
        type: 'slider',
        xAxisIndex: 0,
        start: 0,
        end,
        bottom: 12,
        height: 18,
        brushSelect: false,
        borderColor: chartSplitLineColor,
        fillerColor: isDarkTheme ? 'rgba(51, 153, 255, 0.28)' : 'rgba(50, 104, 184, 0.18)',
        handleStyle: { color: isDarkTheme ? '#8ab4f8' : '#3268b8' },
        textStyle: { color: chartTextColor }
      }];
    };

    const option_by_person_summary = {
        legend: {
            data: ['合同累计收款金额'],
            align: 'left',
            textStyle: { color: chartTextColor }
        },
        tooltip: {
          trigger: 'axis',
          ...chartTooltipStyle,
          axisPointer: {
            type: 'cross',
            label: { color: chartTitleColor }
          }
        },
        grid: {
          left: 70,
          right: 72,
          top: 50,
          bottom: rowCount > visiblePersonCount ? 92 : 68
        },
        dataZoom: dataZoom(visiblePersonCount),
        toolbox: {
          iconStyle: { borderColor: chartTextColor },
          feature: {
            dataView: {},
            saveAsImage: {
                pixelRatio: 2
            }
          }
        },
        xAxis: {
          data: personXAxis,
          silent: true,
          axisLabel: {
            color: chartTextColor,
            interval: 0,
            rotate: -35,
            margin: 14
          },
          axisLine: { lineStyle: { color: chartAxisColor } },
          axisTick: { lineStyle: { color: chartAxisColor } },
          splitLine: {
              show: false
          }
        },
        yAxis: [{
          type: 'value',
          name: '商务人员实收款（万元）',
          position: 'left',
          axisLabel: {
            color: chartTextColor,
            formatter: '{value}万'
          },
          nameTextStyle: { color: chartTitleColor },
          axisLine: { lineStyle: { color: chartAxisColor } },
          axisTick: { lineStyle: { color: chartAxisColor } },
          splitLine: { lineStyle: { color: chartSplitLineColor } }
        }],
        series: [{
          name: '合同累计收款金额',
          type: 'bar',
          data: personRealAmounts,
          barMaxWidth: 46,
          label: {
            show: true,
            position: 'top',
            ...chartDataLabelStyle
          },
          markLine: {
            label: {
              formatter: '平均实收款{c}万',
              ...chartDataLabelStyle
            },
            lineStyle: {
              type: 'solid',
              width: 1
            },
            data: [
              {
                yAxis: avgPersonRealAmounts
              }
            ]
          }
        }]
    };

    const option_by_person_category = {
      tooltip: {
        trigger: 'axis',
        ...chartTooltipStyle,
        axisPointer: {
          type: 'shadow',
          label: { color: chartTitleColor }
        }
      },
      toolbox: {
        iconStyle: { borderColor: chartTextColor },
        feature: {
          dataView: {},
          saveAsImage: {
            pixelRatio: 2
          }
        }
      },
      legend: {
        data: biTypes,
        left: 'center',
        top: '33',
        textStyle: { color: chartTextColor }
      },
      grid: {
        left: 70,
        right: 72,
        top: 72,
        bottom: rowCount > visiblePersonCount ? 100 : 72
      },
      dataZoom: dataZoom(visiblePersonCount),
      xAxis: {
        type: 'category',
        data: personXAxis,
        axisLabel: {
          color: chartTextColor,
          interval: 0,
          rotate: -35,
          margin: 16
        },
        axisLine: { lineStyle: { color: chartAxisColor } },
        axisTick: { lineStyle: { color: chartAxisColor } },
      },
      yAxis: {
        type: 'value',
        name: '万元',
        axisLabel: { color: chartTextColor },
        nameTextStyle: { color: chartTitleColor },
        axisLine: { lineStyle: { color: chartAxisColor } },
        axisTick: { lineStyle: { color: chartAxisColor } },
        splitLine: { lineStyle: { color: chartSplitLineColor } }
      },
      series: biTypeByName,
    };

    function drill_down_people_summary(params) {
      if (params.componentType === 'series') {
        if (params.seriesType === 'bar') {
          const person_name = personXAxis[params.dataIndex];
          const org_code = $('#org-code').val();
          const start_month_name = $('#start-month-name').val();
          const end_month_name = $('#end-month-name').val();
          const sent_data = { person_name, org_code, start_month_name, end_month_name };
          let drill_down_url = '/report/people_department_receive/drill_down_people_summary';

          $.ajax(drill_down_url, {
            data: sent_data,
            dataType: 'script'
          });
        }
      }
    }


    departmentReceiveChartByPersonSummary.setOption(option_by_person_summary, false);
    departmentReceiveChartByPersonSummary.on('click', drill_down_people_summary);
    departmentReceiveChartByPersonCategory.setOption(option_by_person_category, false);

    let syncingDataZoom = false;
    const syncDataZoom = (targetChart) => (params) => {
      if (syncingDataZoom) { return; }

      const zoom = params.batch ? params.batch[0] : params;
      if (zoom.start === undefined || zoom.end === undefined) { return; }

      syncingDataZoom = true;
      targetChart.dispatchAction({
        type: 'dataZoom',
        start: zoom.start,
        end: zoom.end
      });
      syncingDataZoom = false;
    };

    departmentReceiveChartByPersonSummary.on('datazoom', syncDataZoom(departmentReceiveChartByPersonCategory));
    departmentReceiveChartByPersonCategory.on('datazoom', syncDataZoom(departmentReceiveChartByPersonSummary));

    setTimeout(() => {
      departmentReceiveChartByPersonSummary.resize();
      departmentReceiveChartByPersonCategory.resize();
    }, 200);
  }

  layout() {
    departmentReceiveChartByPersonSummary.resize();
    departmentReceiveChartByPersonCategory.resize();
  }

  disconnect() {
    departmentReceiveChartByPersonSummary.dispose();
    departmentReceiveChartByPersonCategory.dispose();
  }
}
